import React from 'react';
import { useVideoConfig } from '../../config/VideoAppContext';
import { useMediaQuery } from '../../hooks/use-media-query';
import { containerPadding } from '../PlayContainer/PlayContainer';
import { Swimlane } from '../Swimlane/Swimlane';
import { SwimlaneTitle } from '../Swimlane/SwimlaneTitle';
import { Swipeable } from '../Swipeable/Swipeable';
import { AspectPlaceholder } from '../Teaser/Placeholder/AspectPlaceholder';
import { MediaElement } from '../TeaserElement/MediaElement';
import { MediaElementContent } from '../TeaserElement/MediaElementContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const aspectRatioRoundingFactorXLarge = 1.16;
export const MediaElementSwimlane = ({
  medias,
  title = ''
}) => {
  const {
    usePreview
  } = useVideoConfig();
  const buttonPositionFactor = useMediaQuery([['mediumDown', 9 / 16], ['large', 5 / 19]], 5 / 19 / aspectRatioRoundingFactorXLarge);
  return (medias && medias.length) === 1 ? /*#__PURE__*/_jsx(MediaElement, {
    media: medias[0],
    title: title,
    index: 0
  }, medias[0].id) : /*#__PURE__*/_jsxs(Swimlane, {
    children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
      title: title
    }), /*#__PURE__*/_jsx(Swipeable, {
      buttonPositionFactor: buttonPositionFactor,
      placeholder: /*#__PURE__*/_jsx(AspectPlaceholder, {
        aspectRatio: 19 / 5,
        isPreview: usePreview
      }),
      config: viewportSwipeableConfig,
      children: medias?.map((media, index) => /*#__PURE__*/_jsx(MediaElementContent, {
        media: media,
        index: index
      }, media.id))
    })]
  });
};
const viewportSwipeableConfig = [['small', {
  itemCount: 1.2,
  spaceBefore: containerPadding.small,
  spaceBetween: 8
}], ['medium', {
  itemCount: 1.2,
  spaceBefore: containerPadding.medium,
  spaceBetween: 16
}], ['large', {
  itemCount: 1.07,
  spaceBefore: containerPadding.large,
  spaceBetween: 16
}], ['xLargeUp', {
  itemCount: 1.07,
  spaceBefore: 0,
  spaceBetween: 16
}]];